import { Box, Container } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Page } from '@larvitu/shared/mui/ui-components';
import { HtmlParser } from '@larvitu/shared/react/components/feature-html-parser';

import { getLayout } from '../lib/getLayout';
import { getServerTranslations } from '../lib/i18n/getServerTranslations';

import type { AppPage } from '../@types/page';
import type { GetStaticProps } from 'next';

const Datenschutz: AppPage = () => {
  const { t } = useTranslation( 'data-privacy' );

  return (
    <Page title="Datenschutz">
      <Container>
        <Box my={16}>
          <HtmlParser>
            {t( 'content' )}
          </HtmlParser>
        </Box>
      </Container>
    </Page>
  );
};

Datenschutz.getLayout = getLayout;

export default Datenschutz;

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => ({
  props: {
    ...(await getServerTranslations( locale, [
      'common',
      'data-privacy',
      'contact',
    ] )),
  },
});
